import { render, staticRenderFns } from "./ViewAnswer.vue?vue&type=template&id=17291a4b&"
import script from "./ViewAnswer.vue?vue&type=script&lang=js&"
export * from "./ViewAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports